import React, { forwardRef, useRef, useImperativeHandle, useCallback, useLayoutEffect } from 'react';

const AutogrowTextarea = forwardRef((props, forwardedRef) => {
  const internalRef = useRef(null);
  useImperativeHandle(forwardedRef, () => internalRef.current);
  const resize = useCallback(() => {
    const el = internalRef.current;
    if (!el)
      return;
    el.style.height = "auto";
    const { boxSizing, paddingTop, paddingBottom, borderTopWidth, borderBottomWidth } = window.getComputedStyle(el);
    const toPx = (value) => parseFloat(value) || 0;
    const verticalPadding = toPx(paddingTop) + toPx(paddingBottom);
    const verticalBorder = toPx(borderTopWidth) + toPx(borderBottomWidth);
    let targetHeight = el.scrollHeight - verticalPadding;
    if (boxSizing === "content-box") {
      targetHeight -= verticalBorder;
    }
    el.style.height = `${Math.max(0, targetHeight)}px`;
  }, []);
  useLayoutEffect(resize, [props.value, resize]);
  const handleInput = (e) => {
    var _a;
    resize();
    (_a = props.onInput) === null || _a === void 0 ? void 0 : _a.call(props, e);
  };
  return React.createElement("textarea", Object.assign({}, props, {
    ref: internalRef,
    /* Prevent the browser’s native resize handle & hide scrollbars */
    style: Object.assign(Object.assign({}, props.style), { overflow: "hidden", resize: "none" }),
    onInput: handleInput
  }));
});
AutogrowTextarea.displayName = "AutogrowTextarea";

export { AutogrowTextarea, AutogrowTextarea as default };
//# sourceMappingURL=AutogrowTextarea.es.js.map
